import { FeeLine, Quote } from "@/offering/api";
import { Order } from "../data/orders";
import { DashboardQuote } from "../hooks/use_dashboard_quote_query";

export function getAllOrderFeeLines(order: Order) {
  const orderItemsFeeLines = order.orderItems.reduce<FeeLine[]>(
    (prev, current) => prev.concat(current.feeLines || []),
    []
  );
  const allFeeLines = orderItemsFeeLines.concat(order.feeLines || []);

  return allFeeLines;
}

export function getAllQuoteFeeLines(quote: Quote | DashboardQuote) {
  const quoteItemsFeeLines = quote.quoteItems.reduce<FeeLine[]>(
    (prev, current) => prev.concat(current.feeLines || []),
    []
  );
  const allFeeLines = quoteItemsFeeLines.concat(quote.feeLines || []);

  return allFeeLines;
}
